import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  width?: string;
  height?: string;
  sx?: object;
  outerPadding?: number;
  titleActions?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  maxWidth,
  width,
  sx,
  outerPadding,
  titleActions,
  height,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      disableEscapeKeyDown
      fullWidth
      disableScrollLock
      sx={{
        zIndex: 1300,
        ...sx,
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: { xs: '0px', md: 2 },
          p: 0,
          maxWidth: { xs: '100%', md: maxWidth || 'lg' },
          width: { xs: '100%', md: width || 'auto' },
          height: height ? height : 'auto',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          pointerEvents: 'auto',
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pt: 1,
            pb: 1,
            px: 2,
            mb: 1,
            position: 'sticky',
            top: 0,
            backgroundColor: 'primary.main',
            zIndex: 10,
          }}
        >
          {/* Left: Title */}
          {typeof title === 'string' ? (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '16px',
                color: '#fff',
              }}
            >
              {title}
            </Typography>
          ) : (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '16px',
                color: '#000',
              }}
            >
              {title}
            </Typography>
          )}

          {/* Right: Actions + Close button */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {titleActions}
            <IconButton
              onClick={onClose}
              sx={{ color: '#fff', '&:hover': { color: 'grey.100' } }}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          p: outerPadding || 2,
          overflowY: 'auto',
          flex: 1,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
